import { NgModule } from '@angular/core';
import { AmdOptionComponent } from './option.component';
export class AmdOptionModule {
}
AmdOptionModule.decorators = [
    { type: NgModule, args: [{
                declarations: [AmdOptionComponent],
                exports: [AmdOptionComponent]
            },] },
];
/**
 * @nocollapse
 */
AmdOptionModule.ctorParameters = () => [];
function AmdOptionModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdOptionModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdOptionModule.ctorParameters;
}
//# sourceMappingURL=option.module.js.map
//# sourceMappingURL=option.module.js.map
